import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import  Header from './components/header';
import  Hero  from './components/hero';
import Footer from './components/footer';
import Container from "./components/container";
// 👉 Como usar:
// 1) Passe sua URL de afiliado da Eduzz via prop `affiliateLink`.
//    <LandingGestaoTempo affiliateLink="https://seu-link-de-afiliado.com" />
// 2) (Opcional) Ajuste textos/cores abaixo conforme seu produto.

export default function LandingGestaoTempo({ affiliateLink = "#" }) {
  const handleCTA = (e) => {
    e.preventDefault();
    if (affiliateLink && affiliateLink !== "#") {
      window.location.href = affiliateLink;
    }
  };

  return (
    <Container className="bg-dark text-light">
      {/* Header / Navbar */}
      <Header affiliateLink={affiliateLink} handleCTA={handleCTA} />
     {/* Hero */}
      <Hero affiliateLink={affiliateLink} handleCTA={handleCTA} />  
    {/* Social proof / marcas (opcional) */}
      <section className="py-4 border-top border-bottom bg-white">
        <div className="container text-center">
          <span className="text-uppercase text-muted small">Pagamento e acesso com segurança pela</span>
          <div className="mt-2 fw-bold">EDUZZ</div>
        </div>
      </section>

      {/* Benefícios */}
      <section className="py-5" id="beneficios">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 col-lg-8 mx-auto text-center">
              <h2 className="fw-bold">Resultados práticos que cabem na sua rotina</h2>
              <p className="text-secondary">Sem planilhas complicadas: passo a passo direto ao ponto para você ganhar foco e tempo todos os dias.</p>
            </div>
          </div>

          <div className="row g-4" style={{ display:"flex", justifyContent:"center"}}>
            {[{
              title: 'Planejamento em 10 minutos',
              desc: 'Aprenda um ritual simples diário que define prioridades e evita sobrecarga.'
            },{
              title: 'Foco Profundo',
              desc: 'Técnicas baseadas em neurociência para trabalhar sem interrupções.'
            },{
              title: 'Rotina Sustentável',
              desc: 'Hábitos mínimos viáveis para manter o progresso sem esforço excessivo.'
            },{
              title: 'Clareza e Energia',
              desc: 'Organize mente e agenda para reduzir ansiedade e procrastinação.'
            }].map((item, idx) => (
              <div className="col-md-6 col-lg-2 shadow-lg" key={idx} style={{margin:"10px 10px 2px 1px",padding: "0px", border:"",boxShadow:"0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius:"0.5rem", overflow:"hidden", backgroundColor:"#fff"}}>
                <div>
                    <img src={`/imagens/foto${idx+1}.png`} alt="imagem" className="img-fluid"/>
                                  
                </div>
                  <div  style={{padding:"1rem", bottom:"0", backgroundColor:"rgba(255, 255, 255, 0.6)", width:"100%", borderBottomLeftRadius:"0.5rem", borderBottomRightRadius:"0.5rem"}}>
                       <h5 className="fw-semibold" style={{color:"#000", fontWeight:"bolder"}}>{item.title}</h5>
                     <p className="text-secondary mb-0" style={{fontWeight:"bold"}}>{item.desc}</p> 
                  </div>  
                 
                </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por que funciona */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <h3 className="fw-bold">Por que este método funciona</h3>
              <p className="text-secondary">Baseado em princípios de gestão do tempo e foco, o treinamento mostra como aplicar um sistema simples e manter consistência, sem fórmulas mirabolantes.</p>
              <ul className="list-unstyled">
                <li className="mb-2">• Passo a passo direto, aplicável no mesmo dia</li>
                <li className="mb-2">• Sem ferramentas obrigatórias ou apps pagos</li>
                <li className="mb-2">• Ajustável para rotinas cheias ou horários apertados</li>
              </ul>
              <a href={affiliateLink} onClick={handleCTA} className="btn btn-primary">Quero Começar</a>
            </div>
            <div className="col-xl-6">
              <div >
                <div className="d-flex align-items-center justify-content-center text-secondary">
                
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </section>

  
      {/* CTA final */}
      <section className="py-5">
        <div className="container">
          <div className="p-4 p-lg-5 bg-primary text-white rounded-3 shadow-sm">
            <div className="row align-items-center g-3">
              <div className="col-lg-8">
                <h3 className="fw-bold mb-2">Pronto para retomar o controle do seu tempo?</h3>
                <p className="mb-0">Clique no botão e tenha acesso imediato ao treinamento completo pela Eduzz. Garantia total de 7 dias.</p>
              </div>
              <div className="col-lg-4 text-lg-end">
                <a href={affiliateLink} onClick={handleCTA} className="btn btn-light btn-lg fw-semibold">Quero Começar Agora</a>
              </div>
            </div>
          </div>
          <p className="small text-muted text-center mt-3 mb-0">Este site é uma página de divulgação independente. Pagamentos e acesso processados pela Eduzz.</p>
        </div>
      </section>

      {/* Footer */}
        <Footer/>
    </Container>
  );
}
